export type CustomFieldType = 'text' | 'text_multiline' | 'email' | 'phone_number' | 'checkbox' | 'date' | 'fiscal_code'

export const SupportedFieldTypes: string[] = ['text', 'text_multiline', 'email', 'phone_number', 'checkbox', 'date', 'fiscal_code']
